module.exports = __webpack_public_path__ + "img/10 parque.7d531683.jpg";